if (!customElements.get('related-slider')) {
  customElements.define('related-slider', class RelatedSlider extends HTMLElement {
    connectedCallback() {
      const template = this.querySelector('template');
      if (!template) return;

      if (!('IntersectionObserver' in window)) {
        this.replaceChildren(template.content.cloneNode(true));
        return;
      }

      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.replaceChildren(template.content.cloneNode(true));
      }, { rootMargin: '400px 0px' });

      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  });
}